<template>
  <div id="resultTable">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6">
          <h2>{{ $t("easi_result") }}</h2>
        </v-col>
        <v-col class="d-flex justify-end">
          <div class="dontPrint">
            <v-btn
              v-if="isAuthenticated"
              :loading="loading"
              class="reportBtn mr-4"
              color="#324c8d"
              @click="$emit('save-patient')"
            >
              {{ evaluating ? $t("save_evaluation") : $t("save_patient") }}
            </v-btn>
            <v-btn class="reportBtn" color="#324c8d" @click="generateReport">
              {{ $t("generate_report") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr id="content">
              <th>{{ $t("body_region") }}</th>
              <th>
                {{ $t("erytem") }}
                <br />(0-3)
              </th>
              <th>
                {{ $t("papules") }}
                <br />(0-3)
              </th>
              <th>
                {{ $t("excoriation") }}
                <br />(0-3)
              </th>
              <th>
                {{ $t("lichenification") }}
                <br />(0-3)
              </th>
              <th>{{ $t("severity_sum") }}</th>
              <th>
                {{ $t("eczema_range") }}
                <br />(0–6)
              </th>
              <th>
                {{ $t("severity_sum") }}
                <br />x
                <br />
                {{ $t("eczema_range") }}
              </th>
              <th>
                {{ $t("multiplicator") }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <i class="fal fa-info-circle fa-lg" />
                    </span>
                  </template>
                  <span>{{ $t("multiplicator_tooltip") }}</span>
                </v-tooltip>
              </th>
              <th>{{ $t("total_score") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in bodyParts" :key="item.name">
              <template v-if="item.data">
                <td>{{ item.name }}</td>
                <td>{{ item.data.erytemSeverity }}</td>
                <td>{{ item.data.papulesSeverity }}</td>
                <td>{{ item.data.exorcationsSeverity }}</td>
                <td>{{ item.data.lichenificationSeverity }}</td>
                <td>
                  {{
                    item.data.erytemSeverity +
                      item.data.papulesSeverity +
                      item.data.exorcationsSeverity +
                      item.data.lichenificationSeverity
                  }}
                </td>
                <td>{{ item.data.rangeScore }}</td>
                <td>
                  {{
                    item.data.rangeScore *
                      (item.data.erytemSeverity +
                        item.data.papulesSeverity +
                        item.data.exorcationsSeverity +
                        item.data.lichenificationSeverity)
                  }}
                </td>
                <td>{{ item.multiplier }}</td>
                <td>
                  {{
                    (item.sum = (
                      item.multiplier *
                      item.data.rangeScore *
                      (item.data.erytemSeverity +
                        item.data.papulesSeverity +
                        item.data.exorcationsSeverity +
                        item.data.lichenificationSeverity)
                    ).toFixed(1))
                  }}
                </td>
              </template>
            </tr>
            <tr id="tableFooter">
              <td class="footerText" colspan="9">{{ $t("final_score") }}</td>
              <td class="easiResult">
                {{
                  (easiResult = (
                    parseFloat(bodyParts[0].sum) +
                    parseFloat(bodyParts[1].sum) +
                    parseFloat(bodyParts[2].sum) +
                    parseFloat(bodyParts[3].sum)
                  ).toFixed(1))
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <evaluationScale :easiResult="easiResult" />
  </div>
</template>

<script>
import evaluationScale from "./evaluationScale.vue";

export default {
  props: [
    "resultHeadNeck",
    "resultUpperLimbs",
    "resultTorso",
    "resultLoweLimbs",
    "loading",
    "evaluating",
    "multiplier"
  ],
  components: {
    evaluationScale
  },
  data() {
    return {
      easiResult: 0,
      bodyParts: [
        {
          name: "Hlava a krk",
          data: this.resultHeadNeck,
          multiplier: this.multiplier[0],
          sum: 0.0
        },
        {
          name: "Horní končetiny",
          data: this.resultUpperLimbs,
          multiplier: this.multiplier[1],
          sum: 0.0
        },
        {
          name: "Trup",
          data: this.resultTorso,
          multiplier: this.multiplier[2],
          sum: 0.0
        },
        {
          name: "Dolní končetiny",
          data: this.resultLoweLimbs,
          multiplier: this.multiplier[3],
          sum: 0.0
        }
      ]
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isUserAuthenticated;
    }
  },
  methods: {
    generateReport() {
      this.$emit("generate-report");
    }
  },
  watch: {
    multiplier() {
      this.multiplier.forEach((m, i) => {
        this.bodyParts[i].multiplier = m;
      });
    }
  }
};
</script>
<style scoped lang="scss">
#tableFooter {
  background: gainsboro;
  .footerText {
    text-align: right;
  }
  .easiResult {
    font-size: 2em;
  }
}

.reportBtn {
  color: white;
}

#resultFlex {
  display: flex;
  justify-content: space-between;
}
td {
  text-align: center;
}
.theme--light.v-data-table thead tr:last-child th {
  text-align: center;
  padding: 1em;
}
.theme--light.v-data-table thead tr:last-child th:first-child {
  text-align: left;
}
table td:first-child {
  text-align: left;
}
.container {
  max-width: 100%;
}

#resultTable {
  .fa-info-circle.fa-lg {
    color: gray;
  }
}

@media only screen and (min-width: 200px) and (max-width: 1263px) {
  .dontPrint {
    width: 100%;
  }

  .reportBtn {
    width: 100%;

    &:nth-of-type(2) {
      margin-top: 1rem;
    }
  }
}
</style>
